import { configureStore } from "@reduxjs/toolkit";
import rootReducer, {type RootState} from "./rootReducer";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});


export type AppDispatch = typeof store.dispatch;
export type AppState = RootState;
export default store;
